import { render, staticRenderFns } from "./ExamCorrectionDetail.vue?vue&type=template&id=3c1be19e&"
import script from "./ExamCorrectionDetail.vue?vue&type=script&lang=js&"
export * from "./ExamCorrectionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports